// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1024px","white":"#ffffff","whiteSmoke":"#f1f1f1","whiteFog":"#f9f9f9","whiteGrey":"#d8d8d8","black":"#262626","grey":"#9d9d9d","lightGrey":"#ccc","primary":"#009fff","secondary":"#009fff","tertiary":"#009fff","error":"#e32438","success":"#79d38a","inactive":"#c6c6c6","billPrimary":"#009fff"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/directory/filter/FilterComponent.scss
// module id = 1731
// module chunks = 0